module.exports = __webpack_public_path__ + "static/media/payout.040f7c58.png";